import React, {useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import {ezprOrange} from '../../_helpers';
import PropTypes from 'prop-types';
import {MasterDataDropdown} from '../utils/MasterDataDropdown.jsx';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {BrickContext} from 'olympe';
import {LAMBDA_NAMES} from '../../../utils/constants';

/**
 * A popup that split the address in many fields and regroup them on save
 *
 * @param {!Object} props
 * @return {JSX.Element}
 */
export const UnitOfMeasurePopup = (props) => {
    const [selectedUoM, setSelectedUoM] = useState({label: props.value, value: ''});

    const useRequestStore = requestStores.get(props.prTag);
    const userIdToCallSAPAPIs = useRequestStore((state) => state.userIdToCallSAPAPIs);

    const getMasterData = props.context.get(LAMBDA_NAMES.GET_MASTER_DATA);

    return (<Dialog
        open={props.open}
        maxWidth={'sm'}
        fullWidth={true}
    >
        <DialogTitle>
            Modify Unit of Measure
        </DialogTitle>
        <DialogContent>
            <Grid
                container
                spacing={2}
                justifyContent={'center'}
                alignItems={'flex-end'}
            >
                <Grid item xs={1}>
                    <TextField
                        disabled
                        variant={'standard'}
                        defaultValue={props.leftValue}
                    />
                </Grid>
                <Grid item xs={3}>
                    <MasterDataDropdown
                        context={props.context}
                        property={'Unit of Measure'}
                        getMasterData={getMasterData}
                        materialNumber={props.materialNumber}
                        selectedValue={selectedUoM}
                        userId={userIdToCallSAPAPIs}
                        placeholder={'UoM'}
                        recentlyUsed
                        onChange={setSelectedUoM}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        =
                    </Box>
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        disabled
                        variant={'standard'}
                        value = {selectedUoM?.value || '1'}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                        disabled
                        label="Unit of Measure"
                        variant={'standard'}
                        value={props.value}
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={props.onCancel}
            >
                Cancel
            </Button>
            <Button
                sx={{
                    'backgroundColor': ezprOrange,
                    'color': 'white',
                    '&:hover': {
                        backgroundColor: '#FC9225',
                        color: 'white',
                    },
                    '&:disabled': {
                        backgroundColor: '#C8C8C8',
                    },
                }}
                disabled={!selectedUoM}
                onClick={() => {
                    props.onSave(selectedUoM);
                }}
            >
                Apply
            </Button>
        </DialogActions>
    </Dialog>);
};

UnitOfMeasurePopup.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    open: PropTypes.bool,
    leftValue: PropTypes.number,
    materialNumber: PropTypes.string.isRequired,
};
